import axios from 'axios'

var url=window.location.hash
var query=''
var contrato =''
var contratoNumero =''

query = url.replace('#','').replace('?',"").replace('/',"").split("=")


if(!isNaN(parseInt(query[1])) && query[1] != undefined ){
  console.log(query[1],"teste")
  contratoNumero=query[1]
  localStorage.setItem('contrato',contratoNumero)
}else{
  contratoNumero = localStorage.getItem('contrato')
}

export const contratoNum=contratoNumero;
export const http = axios.create({
  //baseURL: './', // desenvolvimento
  baseURL: './php-deli', //servidor
  params:{
    c:contratoNumero
  },
  contrato: ''
})

